<template>
    <v-app-bar  style="z-index:300 !important" app clipped-left clipped-right dark color="blue-grey darken-4" >
      <!-- @contextmenu.prevent="handleContextMenu" -->
      <!-- #01579b -->
      <!-- <v-dialog v-model="alertDialog" persistent max-width="500">
        <v-card>
            <v-card-title><span class="headline">更新する必要があります!</span></v-card-title>
            <v-card-text>
              <v-card-subtitle style="font-size: 25px !important;">
                Ctrl+Shift+F5にて更新してください。
              </v-card-subtitle>
            </v-card-text>

        </v-card>
      </v-dialog> -->

    <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }">
        <v-btn class="ml-3" href="/cadrequest" v-on="on" icon>
            <v-icon >mdi-home</v-icon> 
        </v-btn>
        </template>
        <span>ホームに戻る</span>
    </v-tooltip> -->
        <v-tooltip bottom>
        <template v-slot:activator="{ on : tooltip }">
        <v-menu offset-y>
        <template v-slot:activator="{ on : menu, attrs }">
            <v-btn
            icon
            dark
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
            >
            <v-icon>mdi-menu</v-icon>
            </v-btn>
        </template>
        <v-list dense min-width="300" elevation="5">
            <v-container fluid>
                    <v-list-item-group  v-model="menu">
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12">
                        <v-subheader>PAGES</v-subheader>
                        <v-divider></v-divider>
                        <div v-if="loggedInUser.is_admin == 1">
                          <v-list-item
                              v-for="(item, gg) in items"
                              :key="'item'+gg"
                              :to="item.to"
                              active-class="#546E7A" 
                              @click="handleItemClick(item)">
                              <v-list-item-icon>
                                  <v-icon v-text="item.icon" v-if="item.icon == 'mdi-home'"></v-icon>
                                  <v-icon v-text="item.icon" v-else-if="item.icon == 'mdi-book-open'"></v-icon>
                                  <v-icon v-text="item.icon" v-else-if="item.icon == 'mdi-book-open-outline'"></v-icon>
                                  <v-icon v-text="item.icon" v-else-if="item.icon == 'mdi-table-eye'"></v-icon>
                                  <v-icon v-text="item.icon" v-else-if="item.icon == 'mdi-content-paste'"></v-icon>
                                  <v-icon v-text="item.icon" v-else-if="item.icon == 'mdi-format-list-checks'" v-show="loggedInUser.is_admin == 1"></v-icon>
                                  <v-icon v-text="item.icon" v-else-if="item.icon == 'mdi-cog'" v-show="loggedInUser.is_admin == 1"></v-icon>
                                  <v-icon v-text="item.icon" v-else-if="item.icon == 'mdi-download'"></v-icon>
                                  <v-icon v-text="item.icon" v-else-if="item.icon == 'mdi-calendar-month'"  v-show="loggedInUser.is_admin == 1"></v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                  <v-list-item-title v-text="item.text" v-if="item.text != 'Master List'"></v-list-item-title>
                                  <v-list-item-title v-text="item.text" v-else></v-list-item-title>
                              </v-list-item-content>
                          </v-list-item>

                        </div>

                        <!-- <v-list-item
                            v-show="loggedInUser.is_admin == 0"
                            v-for="(itemz, tt) in items2"
                            :key="'itemz'+tt"
                            :to="itemz.to"
                            active-class="#546E7A" 
                            @click="handleItemClickz(itemz)">
                            <v-list-item-icon>
                                <v-icon v-text="itemz.icon" v-if="itemz.icon == 'mdi-home'"></v-icon>
                                <v-icon v-text="itemz.icon" v-else-if="itemz.icon == 'mdi-book-open'" v-show="loggedInUser.is_gc_user == 1 || loggedInUser.is_ichijo_user == 1 || loggedInUser.is_rulebook_user == 1"></v-icon>
                                <v-icon v-text="itemz.icon" v-else-if="itemz.icon == 'mdi-book-open-outline'" v-show="loggedInUser.is_hrd_requestor == 1 || loggedInUser.is_hrd_viewer == 1 || loggedInUser.plan_control ==1"></v-icon>
                                <v-icon v-text="itemz.icon" v-else-if="itemz.icon == 'mdi-table-eye'"></v-icon>
                                <v-icon v-text="itemz.icon" v-else-if="itemz.icon == 'mdi-content-paste'"></v-icon>
                                <v-icon v-text="itemz.icon" v-else-if="itemz.icon == 'mdi-download'"  v-show="loggedInUser.is_hrd_requestor != 1 && loggedInUser.plan_control != 1"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content v-if="itemz.text == 'CAD Request Form(Excel)'">
                                <v-list-item-title v-show="loggedInUser.is_hrd_requestor != 1 && loggedInUser.plan_control != 1" v-text="itemz.text"></v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-content v-else>
                                <v-list-item-title v-text="itemz.text"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item> -->

                        <div v-else-if="loggedInUser.is_gc_user == 1 || loggedInUser.is_ichijo_user == 1 || loggedInUser.is_rulebook_user == 1 || loggedInUser.japan_admin == 1">
                        <!-- With Japanese Manual -->
                          <v-list-item
                            v-for="(itemJap, vp) in itemManualJap"
                            :key="'itemJap' +vp"
                            :to="itemJap.to"
                            active-class="#546E7A"
                            @click="handleItemJapan(itemJap)">
                            <v-list-item-icon>
                                <v-icon v-text="itemJap.icon" v-if="itemJap.icon == 'mdi-home'"></v-icon>
                                <v-icon v-text="itemJap.icon" v-else-if="itemJap.icon == 'mdi-book-open'"></v-icon>
                                <v-icon v-text="itemJap.icon" v-else-if="itemJap.icon == 'mdi-table-eye'"></v-icon>
                                <v-icon v-text="itemJap.icon" v-else-if="itemJap.icon == 'mdi-content-paste'"></v-icon>
                                <v-icon v-text="itemJap.icon" v-else-if="itemJap.icon == 'mdi-download'" v-show="loggedInUser.is_hrd_requestor != 1 && loggedInUser.plan_control != 1"></v-icon>
                                <v-icon v-text="itemJap.icon" v-else-if="itemJap.icon == 'mdi-calendar-month'" v-show="loggedInUser.is_hrd_requestor != 1 && loggedInUser.plan_control != 1"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content v-if="itemJap.text == 'CAD Request Form(Excel)'">
                                  <v-list-item-title v-show="loggedInUser.is_hrd_requestor != 1 && loggedInUser.plan_control != 1" v-text="itemJap.text"></v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-content v-else>
                                  <v-list-item-title v-text="itemJap.text"></v-list-item-title>
                              </v-list-item-content>
                          </v-list-item>
                        </div>

                        <div v-else-if="loggedInUser.is_hrd_requestor == 1 || loggedInUser.plan_control == 1">
                        <!-- With English Manual -->
                          <v-list-item
                            v-for="(itemEng, bm) in itemManualEng"
                            :key="'itemEng' +bm"
                            :to="itemEng.to"
                            active-class="#546E7A"
                            @click="handleItemEng(itemEng)">
                            <v-list-item-icon>
                                <v-icon v-text="itemEng.icon" v-if="itemEng.icon == 'mdi-home'"></v-icon>
                                <v-icon v-text="itemEng.icon" v-else-if="itemEng.icon == 'mdi-book-open'"></v-icon>
                                <v-icon v-text="itemEng.icon" v-else-if="itemEng.icon == 'mdi-table-eye'"></v-icon>
                                <v-icon v-text="itemEng.icon" v-else-if="itemEng.icon == 'mdi-content-paste'"></v-icon>
                                <v-icon v-text="itemEng.icon" v-else-if="itemEng.icon == 'mdi-download'" v-show="loggedInUser.is_hrd_requestor != 1 && loggedInUser.plan_control != 1"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content v-if="itemEng.text == 'CAD Request Form(Excel)'">
                                  <v-list-item-title v-show="loggedInUser.is_hrd_requestor != 1 && loggedInUser.plan_control != 1" v-text="itemEng.text"></v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-content v-else>
                                  <v-list-item-title v-text="itemEng.text"></v-list-item-title>
                              </v-list-item-content>
                          </v-list-item>
                        </div>

                        <div v-else-if="loggedInUser.is_hrd_viewer == 1">
                        <!-- HRD Viewer -->
                          <v-list-item
                            v-for="(itemView,gt) in itemViewer"
                            :key="'itemView' +gt"
                            :to="itemView.to"
                            active-class="#546E7A"
                            @click="handleItemClick(itemView)">
                            <v-list-item-icon>
                              <v-icon v-text="itemView.icon" v-if="itemView.icon == 'mdi-home'"></v-icon>
                              <v-icon v-text="itemView.icon" v-else-if="itemView.icon == 'mdi-table-eye'"></v-icon>
                            </v-list-item-icon>
                              <v-list-item-content>
                                  <v-list-item-title v-text="itemView.text" v-if="itemView.text != 'Master List'"></v-list-item-title>
                                  <v-list-item-title v-text="itemView.text" v-else></v-list-item-title>
                              </v-list-item-content>
                          </v-list-item>
                        </div>

                        </v-col>
                    </v-row>
                    </v-list-item-group>
            </v-container>
        </v-list>
        </v-menu>
        </template>
        <span>Menu</span>
    </v-tooltip>

    <!-- <template>
        <v-tooltip bottom >
            <template v-slot:activator="{ on }" > 
                <v-btn icon v-on="on" href="master_settings/house_types"  v-show="loggedInUser.is_admin == 1">
                    <v-icon>mdi-cog</v-icon> 
                </v-btn>
            </template>
            <span>Master Settings</span>
        </v-tooltip>
    </template> -->

    <v-toolbar-title> <span class="overline">CAD REQUEST V2.{{ $store.state.verHeader }}</span>
    <!-- <v-btn icon dense @click="downloadManual()"> -->
      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-if="loggedInUser.is_admin != 1 && loggedInUser.is_hrd_requestor != 1 && loggedInUser.is_hrd_viewer != 1
            && loggedInUser.plan_control != 1 && (loggedInUser.is_gc_user == 1 || loggedInUser.is_ichijo_user == 1 || loggedInUser.is_rulebook_user == 1)"
            dark
            v-bind="attrs"
            v-on="on"
            @click="downloadManual(2)"
          >
            mdi-help-circle-outline
          </v-icon>
          <v-icon
            v-else-if="loggedInUser.is_admin == 1 || loggedInUser.is_hrd_requestor == 1 || loggedInUser.is_hrd_viewer != 1
            || loggedInUser.plan_control == 1"
            dark
            v-bind="attrs"
            v-on="on"
            @click="downloadManual(1)"
          >
            mdi-information-outline
          </v-icon>
        </template>
        <span class="text-center">CRS Manual</span>
      </v-tooltip> -->
    <!-- </v-btn> -->
    </v-toolbar-title>
    <v-app-bar-title>
        <v-alert
          class="mt-4 ml-3"
          transition="scroll-x-transition"
          v-model="alert"
          dense
          dismissible
          color="#04b8f7"
          border="left"
          width="425px"
          elevation="2"
          colored-border
          icon="mdi-alert-circle"
          >新バージョンにアップデートしました。
          2.{{ $store.state.verHeader }}
        </v-alert>
    </v-app-bar-title>
      
    <v-spacer></v-spacer>
    <!-- <v-icon class="mr-5" large>mdi-information-outline</v-icon> -->

    <v-app-bar-title>
      <v-alert
          v-model="reminder"
          class="mt-4 ma-n1 ml-n1"
          transition="scroll-x-transition"
          colored-border
          width="530px"
          dense
          dark
          color="#04b8f7"
          border="right"
          elevation="2"
          icon="mdi-alert-circle">
        <span class="textPosition">
          バージョンが古い場合またはページが開かない場合は、Ctrl+F5にて更新してください。
        </span>
      </v-alert>
    </v-app-bar-title>

    <v-tooltip bottom color="white">
      <template v-slot:activator="{on,attrs}">
        <v-btn icon medium class="mr-2">
          <v-icon
            @click="reminder = !reminder"
            color="#04b8f7"
            medium
            v-bind="attrs"
            v-on="on">
            mdi-exclamation-thick</v-icon>
        </v-btn>
      </template>
        <span class="black--text">Reminder</span>
    </v-tooltip>

    <v-tooltip bottom color="white">
      <template v-slot:activator="{ on, attrs }" v-if="this.$route.path !== '/notice'">
        <!-- <v-btn @click="openNotice()" icon small class="mr-3" v-if="$store.state.loggedInUser.user_id == '06995' || $store.state.loggedInUser.user_id == 'CRS2025' || $store.state.loggedInUser.user_id == 'HRD12725'"> -->
        <v-btn @click="openNotice()" icon small class="mr-3" v-if="$store.state.loggedInUser.is_admin == 1">
          <v-badge
            bordered
            :value="notices"
            :content="notices"
            color="red"
            overlap>
              <v-icon
                medium
                v-bind="attrs"
                v-on="on">mdi-bulletin-board
              </v-icon>
          </v-badge>
        </v-btn>
      </template>
      <span class="black--text">Master Update Notice</span>
    </v-tooltip>

    <v-icon class="mr-3" v-if="($store.state.loggedInUser.user_id == '39840' || $store.state.loggedInUser.user_id == '06995' || $store.state.loggedInUser.user_id == 'CRS2025')" @click="systemMaintenanceDialog = true">mdi-pen</v-icon>

    <v-tooltip bottom color="white">
      <template v-slot:activator="{ on, attrs }" v-if="this.$route.path !== '/feedBack'">
        <v-btn @click="feedbackOpen()" icon small class="mr-3" :disabled="loggedInUser.is_hrd_requestor == 1">
          <v-badge
            bordered
            :value="feedbackMessages"
            :content="feedbackMessages"
            color="red"
            overlap>
              <v-icon
                medium
                v-bind="attrs"
                v-on="on">mdi-message-reply-text-outline
              </v-icon>
          </v-badge>
        </v-btn>
      </template>
      <span class="black--text">Feedback Tab</span>
    </v-tooltip>
  
    <!-- @click="logOpen()"  -->
    <!-- <v-tooltip bottom color="white">
      <template v-slot:activator="{ on, attrs }" v-if="this.$route.path !== '/logs'">
        <v-btn @click="logOpen()" icon small class="mr-2">
          <v-icon
            medium
            v-bind="attrs"
            v-on="on">
            mdi-information-outline
          </v-icon>
        </v-btn>
      </template>
      <span class="black--text">System Logs</span>
    </v-tooltip> -->

    <!-- MAS ORGANIZE DAW TO -->
    <v-menu transition="slide-y-transition" bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-list style="background-color:transparent;" class="ma-0 pa-0">
          <v-list-item class="ma-0 pa-0">
            <v-list-item-title>
              <v-btn icon small class="mr-5">
                <v-icon
                  medium
                  v-bind="attrs"
                  v-on="on">
                  mdi-information-outline
                </v-icon>
              </v-btn>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </template>

      <v-list>
        <v-list-item>
          <v-list-item-title class="mt-2">
            <v-icon medium class="mb-1">mdi-history</v-icon><input text type="submit" style="font-size:15px;" value="   System Logs" @click="logOpen()" >
          </v-list-item-title>
        </v-list-item>

        <v-list-item v-if="loggedInUser.type == 'Admin' || loggedInUser.type == 'Plan Control' || loggedInUser.type == 'HRD Requestor'">
          <v-list-item-title class="mt-2">
            <v-icon class="mb-1">mdi-download</v-icon><input text type="submit" style="font-size:15px;" value="   User Manual(English)" @click="downloadManual(1)" >
          </v-list-item-title>
        </v-list-item>
        <!-- || loggedInUser.type == 'Plan Control' -->
        <v-list-item v-if="loggedInUser.type == 'Admin' || loggedInUser.type == 'Planner' || loggedInUser.type == 'Japan Admin' || loggedInUser.type == 'Plan Control'">
          <v-list-item-title class="mt-2">
            <v-icon class="mb-1">mdi-download</v-icon><input text type="submit" style="font-size:15px;" value="   User Manual(Japanese)" @click="downloadManual(2)" >
          </v-list-item-title>
        </v-list-item>

        <v-list-item v-if="loggedInUser.is_admin == 1 || loggedInUser.is_gc_user == 1 || loggedInUser.is_ichijo_user == 1 || 
          loggedInUser.is_rulebook_user == 1 || loggedInUser.japan_admin == 1 || loggedInUser.is_hrd_requestor == 1 || loggedInUser.plan_control == 1">
          <v-list-item-title class="mt-2">
            <v-icon class="mb-1">mdi-download</v-icon><input text type="submit" style="font-size:15px;" value="   CAD Request Form(Excel)" @click="cadFormExcel()" >
          </v-list-item-title>
        </v-list-item>
        
        <v-list-item v-if="loggedInUser.type == 'Admin' || loggedInUser.type == 'Planner' || loggedInUser.type == 'Japan Admin'">
          <v-list-item-title class="mt-2">
            <v-icon class="mb-1">mdi-calendar-month</v-icon><input text type="submit" style="font-size:14px;" value="   図面仕上がり予定表" @click="openDSS()" >
          </v-list-item-title>
        </v-list-item>

      </v-list>
    </v-menu>

    <!-- USER MANUAL FOR ENGLISH FERSON -->
    <!-- <v-tooltip bottom color="white">
      <template v-slot:activator="{on,attrs}">
        <v-btn icon small class="mr-2" @click="downloadManual(1)" v-if="loggedInUser.type == 'Admin' || loggedInUser.type == 'Plan Control' || loggedInUser.type == 'HRD Requestor'">
          <v-icon
            medium
            v-bind="attrs"
            v-on="on">
            mdi-account-question-outline</v-icon>
        </v-btn>
      </template>
        <span class="black--text">User Manual(English)</span>
    </v-tooltip> -->

    <!-- USER MANUAL FOR JAPAN USER(S) -->
    <!-- <v-tooltip bottom color="white">
      <template v-slot:activator="{on,attrs}">
        <v-btn icon small class="mr-2" @click="downloadManual(2)" v-if="loggedInUser.type == 'Admin' || loggedInUser.type == 'Planner' || loggedInUser.type == 'Japan Admin'">
          <v-icon
            medium
            v-bind="attrs"
            v-on="on">
            mdi-account-question-outline</v-icon>
        </v-btn>
      </template>
        <span class="black--text">User Manual(Japanese)</span>
    </v-tooltip> -->

    <!-- 図面仕上がり予定表 -->
    <!-- <v-tooltip bottom color="white">
      <template v-slot:activator="{on,attrs}">
        <v-btn icon small class="mr-4" @click="openDSS()" v-if="loggedInUser.type == 'Admin' || loggedInUser.type == 'Planner' || loggedInUser.type == 'Japan Admin'">
          <v-icon
            medium
            v-bind="attrs"
            v-on="on">
            mdi-calendar-month</v-icon>
        </v-btn>
      </template>
        <span class="black--text">図面仕上がり予定表</span>
    </v-tooltip> -->

    <div class="text-center">
      <div v-if="loggedInUser.is_hrd_viewer == 1">
        <span class="caption">{{ authUser.type }}</span>
      </div>
      <div v-else>
        <span class="caption"><b>{{ authUser.name }}</b></span><br/>
        <span class="caption">{{ authUser.type }}</span>
      </div>
    </div>

    <v-tooltip bottom>
        <template v-slot:activator="{ on : tooltip }">
        <v-menu offset-y max-width="300">
        <template v-slot:activator="{ on : menu, attrs }">
            <v-btn
            icon
            dark
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
            >
            <v-icon>mdi-account-circle</v-icon>
            </v-btn>
        </template>
        <v-list dense width="120">
            <v-subheader>ACCOUNT</v-subheader>
            <v-list-item-group>
                <v-list-item >
                <v-list-item-content>
                    <v-form id="logOut" >
                        <input type="hidden" name="_token" :value="csrf">
                        <v-icon>mdi-logout</v-icon>
                        <input  class="caption" text type="submit" value="Logout" depressed @click="logOut()">
                    </v-form>
                </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        </v-menu>
        </template>
        <span>Menu</span>
    </v-tooltip>

    <v-dialog v-model="systemMaintenanceDialog" height="220" width="300px">
      <v-card>
          <v-card-text>
              <v-card-title>Edit Date and Time</v-card-title>
              <!-- <h4 style="color: blue;">システムメンテナンスのため、下記時間帯のシステムの利用ができません。</h4>
                      <br/>
                      <h4 style="color: red;">使用不可の時間帯</h4>
                      <h4 style="color: red;">{{japanDate}} {{japanTime}}（日本時間）</h4>
                      <h4 style="color: red;">※{{philippineTime}}（フィリピン時間）</h4> -->
              <v-text-field v-model= "japanDate" label="Japan Date" class="text mt-3" hide-details outlined dense></v-text-field>
              <v-text-field v-model= "japanTime" label="Japan Time" class="text" hide-details outlined dense></v-text-field>
              <v-text-field v-model= "philippineTime" label="Philippine Time" class="text" hide-details outlined dense></v-text-field>
              <v-select :items="maintenanceItems" item-text="text" item-value="value" v-model= "isMaintenance" label="Maintenance Type"  class="text" hide-details outlined dense></v-select>
          </v-card-text>
          <v-card-actions>
              <v-spacer/>
              <v-btn @click="updateDateTime()" medium color="success">SAVE</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- <dialog-master-list 
      @toggleDialogMasterList="toggleDialogMasterList"
      :dialog="dialogMasterList"
    ></dialog-master-list> -->

    </v-app-bar>
</template>
<script>
// import DialogMasterList from '../components/main-page-modules/DialogMasterList';
import AWS from 'aws-sdk';
import { mapState , mapActions } from 'vuex';
import moment from 'moment';

export default {

  // components: {
  //   'dialog-master-list': DialogMasterList,
  // },

  props : {
    drawer : {
      type: Boolean
    }
  },

  data: () => ({ 
    japanDate: '',
    japanTime: '',
    philippineTime: '',
    isMaintenance: null,
    maintenanceItems: [
        {text: "0", value:0},
        {text: "1", value:1},
        {text: "2", value:2}
    ],
     systemMaintenanceDialog: false,
    // alertDialog: true,
    latestVer: '',
    feedbackData : [],
    dateToday: moment().format("YYYY-MM-DD"), 
    alert : false,
    reminder: false,
    // verHeader : '',
    hideIcon : false,
    csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    menu: null,
    items:[
            {text:'Home', icon:'mdi-home', to:'/home'},
            // {text:'User Manual(Japanese)', icon:'mdi-book-open'},
            // {text:'User Manual(English)', icon:'mdi-book-open-outline'},
            {text:'CAD Request', icon:'mdi-content-paste', to:'/cadrequest'},
            {text:'View Table', icon:'mdi-table-eye', to:'viewtable'},
            {text:'Master List', icon:'mdi-format-list-checks', to:'/masterlist'},
            {text: 'Master Settings', icon:'mdi-cog'},
            // {text:'CAD Request Form(Excel)', icon:'mdi-download'},
            // {text:'図面仕上がり予定表', icon:'mdi-calendar-month'},
            // {text: 'Tile Colors', icon: 'mdi-format-color-fill', to : 'tile'},
            // {text: 'Planners Table', icon: 'mdi-account-details', to : 'planners_table'},
            // {text: 'Entrance Door', icon: 'mdi-door-sliding', to : 'entrance'},
        ],
    // items2:[
    //         {text:'Home', icon:'mdi-home', to:'/cadrequest'},
    //         {text:'CAD Request', icon:'mdi-content-paste', to:'/main'},
    //         {text:'View Table', icon:'mdi-table-eye', to:'home'},
    //         {text:'CAD Request Form(Excel)', icon:'mdi-download'},
    // ],
    itemManualJap:[
            {text:'Home', icon:'mdi-home', to:'/home'},
            // {text:'User Manual(Japanese)', icon:'mdi-book-open'},
            {text:'CAD Request', icon:'mdi-content-paste', to:'/cadrequest'},
            {text:'View Table', icon:'mdi-table-eye', to:'viewtable'},
            // {text:'CAD Request Form(Excel)', icon:'mdi-download'},
            // {text:'図面仕上がり予定表', icon:'mdi-calendar-month'},
    ],
    itemManualEng:[
            {text:'Home', icon:'mdi-home', to:'/home'},
            // {text:'User Manual(English)', icon:'mdi-book-open'},
            {text:'CAD Request', icon:'mdi-content-paste', to:'/cadrequest'},
            {text:'View Table', icon:'mdi-table-eye', to:'viewtable'},
            // {text:'CAD Request Form(Excel)', icon:'mdi-download'},
    ],

    itemViewer:[
            {text:'Home', icon:'mdi-home', to:'/home'},
            {text:'View Table', icon:'mdi-table-eye', to:'viewtable'},
    ],


        // dialogMasterList : false,
        systemLogsData : [],

        createdDate : (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        feedbackMessages : 0,
        
    notices: 0,
    
  }),
      // async beforeCreate(){
      //   await this.$store.dispatch('cadRequestVer').then(() => {
      //     this.latestVer = this.cadRequestVersion.version
      //   })
      // },

  computed: {
    ...mapState([
        'loggedInUser',
        'cadRequestVersion',
        'verHeader'
      ]),

      authUser(){
            if(this.$store.state.loggedInUser.is_admin == 1){
                this.$store.state.loggedInUser.type ='Admin'
            }
            
            // else if(this.$store.state.loggedInUser.is_special_account == 1){
            //     this.$store.state.loggedInUser.type ='Special'
            // }

            else if(this.$store.state.loggedInUser.is_special_account == 1 || this.$store.state.loggedInUser.is_gc_user == 1 || this.$store.state.loggedInUser.is_ichijo_user == 1 || this.$store.state.loggedInUser.is_rulebook_user == 1){
                this.$store.state.loggedInUser.type ='Planner'
            }

            else if(this.$store.state.loggedInUser.is_hrd_requestor == 1){
              this.$store.state.loggedInUser.type = 'HRD Requestor'
            }

            else if(this.$store.state.loggedInUser.is_hrd_viewer == 1){
              this.$store.state.loggedInUser.type = 'HRD Viewer'
            }

            else if(this.$store.state.loggedInUser.japan_admin == 1){
              this.$store.state.loggedInUser.type = 'Japan Admin'
            }

            else if(this.$store.state.loggedInUser.plan_control == 1){
              this.$store.state.loggedInUser.type = 'Plan Control'
            }


        return this.$store.state.loggedInUser;
      },

      canViewMaintenance(){
        if(this.authUser.role.name === 'Admin') return true
        if(typeof _.find(this.authUser.permissions,{ name : 'maintenance-page'}) === 'object' ) return true;
      },

      getCurrentRoute(){
          let route = this.$route.name
          return route.toLowerCase();
      },

  },
  created() {
    this.menu = this.selectedMenu    
  },

  beforeDestroy() {
      // Remove the keydown event listener when the component is destroyed
      // window.removeEventListener('keydown', this.handleKeyDown);
  },

  mounted() {
    //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        this.getSytemMaintenanceDatetime();
    // window.addEventListener('keydown', this.handleKeyDown);
    this.cadRequestVer().then(() => {
      // this.$store.state.verHeader = this.cadRequestVersion.version
          // When the page loads
            // if (this.$store.state.verHeader != this.latestVer) {
            //     this.loader = true;
            //       alert('新しいシステムアップデートがあります。 もう一度ログインしてください。')
            //       const HEADERS = {
            //             'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            //       }
            //       this.$store.commit('logout');
            //       let formdata = new FormData();
            //       formdata.append('_token', HEADERS['X-CSRF-TOKEN']);
            //       axios.post('/logout', formdata, { headers: HEADERS}).finally(() =>  location.reload());
            // } 
          this.newUpdateVersion();
          // this.getUpdatedVersion();
          this.getFeedbacks();
          this.getNotices();

          // if(this.$route.path == '/feedBack'){
          //   console.log('feedback')
          // } else {
          //   console.log('woow')
          // }
          
      // console.log(this.cadRequestVersion.version,'metal head')
    });

    
    


  },

  methods: {
    ...mapActions([
        'cadRequestVer',
        'getUpdatedVersion'
    ]),
     //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        async getSytemMaintenanceDatetime(){
            await axios({
                method: 'get',
                url: 'api/system_maintenance_datetime'
            }).then(({data}) => {
                this.japanDate = data[0].japan_date;
                this.japanTime = data[0].japan_time;
                this.philippineTime = data[0].ph_time;
                this.isMaintenance = data[0].is_undermaintenance;
            })
        },

        //NOTE - REQUEST CODE SSD25-0227783-2028(2025/03/28)
        async updateDateTime(){
            await axios({
                method: 'post',
                url: 'api/update_system_maintenance',
                data: {
                    japan_date: this.japanDate,
                    japan_time: this.japanTime,
                    ph_time: this.philippineTime,
                    is_undermaintenance: this.isMaintenance
                }
            }).then(({data}) => {
                this.getSytemMaintenanceDatetime();
                this.systemMaintenanceDialog = false;
                location.reload();
            })
        },

      downloadManual(lang){
        this.$store.state.forMainOverlay = lang;
        if(this.$store.state.forMainOverlay && this.$route.path == '/cadrequest'){ // For overlay basic information if download file is being trigger
          this.$store.state.overlayMain = true;
        }
        this.$store.state.loaderx = true;
        // axios.get(`crs_manual/${lang}`, {
        //   headers: {
        //     'Content-Type': 'application/json'
        //   }
        // })
        // .then(response => {
        //     if (response.config) {
        //       window.open(response.config.url, '_blank');
        //     } else {
        //       alert("NO FILE FOUND. Please upload CAD Request Manual!");
        //     }
        //   })
        // .catch(error => {
        //     console.error(error);
        //   });
        axios({
            method:'get',
            url:`crs_manual/${lang}`,
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(()=>{
            window.open(`crs_manual/${lang}`, '_blank');
            this.$store.state.loaderx = false;
            this.$store.state.overlayMain = false;
        }).catch(err => {
          this.$store.state.loaderx = false;
          alert("NO FILE FOUND. Please upload CAD Request Manual!");
        })
      },

      openDSS(){
        window.open('openDssPdf', '_blank');
      },

      cadFormExcel(){
        this.$store.state.loaderx = true;
        axios({
              method:'get',
              url:`cad_form_excel`,
              headers: {
                  'Content-Type': 'application/json'
              }
          }).then(()=>{
              window.open('cad_form_excel', '_blank');
              this.$store.state.loaderx = false;
          }).catch(err => {
            alert("NO FILE FOUND. Please upload CAD Request Excel first!");
          })
      },

      handleItemClick(item) {
        this.$store.state.customerCodeFromView = null
        this.$store.state.getXml = null
        if(item.text === 'Master Settings'){
          window.location.href='/master_settings/house_types';
          console.clear();
        }
        // console.log(item.to,'item')
        // if (item.text === 'CAD Request Form(Excel)') {
        //   // Handle click logic if needed
        //   // For example, you can make an API request to the endpoint
        //   // using libraries like Axios or fetch
        //     axios({
        //         method:'get',
        //         url:`cad_form_excel`,
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     }).then(()=>{
        //         window.open('cad_form_excel', '_blank');
        //     }).catch(err => {
        //       alert("NO FILE FOUND. Please upload CAD Request Excel first!");
        //     })
        // }
        // else if(item.text == '図面仕上がり予定表'){
        //   window.open('openDssPdf', '_blank');
              // AWS.config.update({
              //     region: "us-east-2",
              //     accessKeyId: process.env.MIX_AWS_ACCESS_KEY_ID,
              //     secretAccessKey: process.env.MIX_AWS_SECRET_ACCESS_KEY,
              // });

              // let s3 = new AWS.S3();

              // return new Promise((resolve, reject) => {
              //     let params = {
              //       Bucket: "rulebook.files",
              //       Key: `SekkeiGyoumu/100-9-012-20230605101141.pdf`,
              //       ResponseContentDisposition:
              //         "attachment; filename=" +
              //         encodeURIComponent(`100-9-012-20230605101141.pdf`, "UTF-8"),
              //     };

              //       s3.getObject(params, (error, data) => {
              //           if (error) {
              //               reject(error);
              //           } else {
              //               // Instead of zipping, initiate download for each file
              //               const blob = new Blob([data.Body], { type: data.ContentType });
              //               const url = URL.createObjectURL(blob);

              //               // Open the URL in a new tab
              //               window.open(url, '_blank');

              //               console.log('PDF file opened in a new tab');
              //           }
              //       });
              // });
        // }

        // if(item.text == 'User Manual(Japanese)'){
        //   this.downloadManual(2)
        // }

        // if(item.text == 'User Manual(English)'){
        //   this.downloadManual(1)
        // }
      },
      handleItemClickz(itemz){
        // if (itemz.text === 'CAD Request Form(Excel)') {
        //   // Handle click logic if needed
        //   // For example, you can make an API request to the endpoint
        //   // using libraries like Axios or fetch
        //     axios({
        //         method:'get',
        //         url:`cad_form_excel`,
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     }).then(()=>{
        //         window.open('cad_form_excel', '_blank');
        //     }).catch(err => {
        //       alert("NO FILE FOUND. Please upload CAD Request Excel first!");
        //     })
        // }else if(itemz.text == '図面仕上がり予定表'){
        //   window.open('openDssPdf', '_blank');
        // }

        if(itemz.text === 'Master Settings'){
          window.location.href='/master_settings/house_types';
          console.clear();
        }

        // if(itemz.text == 'User Manual(Japanese)'){
        //   this.downloadManual(2)
        // }

        // if(itemz.text == 'User Manual(English)'){
        //   this.downloadManual(1)
        // }
      }, // Hindi na ginagamit

      handleItemJapan(itemJap){
        // if (itemJap.text === 'CAD Request Form(Excel)') {
        //   // Handle click logic if needed
        //   // For example, you can make an API request to the endpoint
        //   // using libraries like Axios or fetch
        //     axios({
        //         method:'get',
        //         url:`cad_form_excel`,
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     }).then(()=>{
        //         window.open('cad_form_excel', '_blank');
        //     }).catch(err => {
        //       alert("NO FILE FOUND. Please upload CAD Request Excel first!");
        //     })
        // }else if(itemJap.text == '図面仕上がり予定表'){
        //   window.open('openDssPdf', '_blank');
        // }

        if(itemJap.text === 'Master Settings'){
          window.location.href='/master_settings/house_types';
          console.clear();
        }

        // if(itemJap.text == 'User Manual(Japanese)'){
        //   this.downloadManual(2)
        // }
      },

      handleItemEng(itemEng){
        // if (itemEng.text === 'CAD Request Form(Excel)') {
        //   // Handle click logic if needed
        //   // For example, you can make an API request to the endpoint
        //   // using libraries like Axios or fetch
        //     axios({
        //         method:'get',
        //         url:`cad_form_excel`,
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     }).then(()=>{
        //         window.open('cad_form_excel', '_blank');
        //     }).catch(err => {
        //       alert("NO FILE FOUND. Please upload CAD Request Excel first!");
        //     })
        // }

        if(itemEng.text === 'Master Settings'){
          window.location.href='/master_settings/house_types';
          console.clear();
        }

        // if(itemEng.text == 'User Manual(English)'){
        //   this.downloadManual(1)
        // }
      },

    // GET FEEDBACK NOTIFICATION(S)
    getFeedbacks(){
        axios({
            method: "POST",
            url: "api/getFeedbackData"
        }).then(({data}) => {
            this.feedbackData = data;
            // console.log(this.feedbackData,'data')

            let getNotif = this.feedbackData.filter((v) => {
            const createdAtLocal = new Date(v.created_at); // Create new date or ni convert talaga sya into date kasi naka string sya
            const createdAtLocalString = createdAtLocal.toLocaleDateString('en-CA', { // Ginawa nya itong string format para sa date YYYY-MM-DD
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            });
              return createdAtLocalString == this.createdDate;
              // return v.created_at.slice(0,10) == this.createdDate;
            })
            this.feedbackMessages = getNotif ? getNotif.length : ''
            // console.log(this.createdDate,'createdDate')
            // console.log(getNotif,'getNotifs')
        })
    },

    getNotices(){
      try {
        axios({
          method:'get',
          url:'api/getMasterNotice'
        }).then((r)=>{
          // this.notices = r.data.length
          let data = r.data.filter((v) => {
            // const createdAtLocal = new Date(v.created_at);
            // const createdAtLocalString = createdAtLocal.toLocaleDateString('en-CA', {
            //   year: 'numeric',
            //   month: '2-digit',
            //   day: '2-digit',
            // });
            // return createdAtLocalString == this.createdDate;

            return v.isReplied == 0
          })
          this.notices = data ? data.length : null
        })
      } catch (error) {
        console.log(error)
      }
    },

    feedbackOpen(){
      window.open('feedBack')
    },

    openNotice(){
      window.open('notice')
    },

    logOpen(){
      window.open('logs')
    },

    newUpdateVersion(val){
      val = this.cadRequestVersion
        // console.log(val,'val')
        var getToday = moment(this.dateToday);
        var getUpdate = moment(val.created_at).format('YYYY-MM-DD');
        // console.log(getUpdate,'getUpdate')

        var lessDay = getToday.diff(getUpdate, 'days')
        // console.log(lessDay, 'lessDay')

        if(lessDay <= 3){
          this.alert = true;
          this.reminder = true;
            setTimeout(() => {
              this.reminder = false;
            }, 100000);
        }

        // if(getToday == getUpdate){
        //   this.alert = true;
        //   this.reminder = true;
        //     setTimeout(() => {
        //       this.reminder = false;
        //     }, 100000);
        // }
      },

    checkLoggedInUser(){
        if(!this.loggedInUser.is_hrd_viewer){
            this.hideIcon = false;
        }
        // console.log(this.columnRestriction)
    },

    emitDialogValue(value){
      this.$emit('emitDialogValue', value);
    },

    toggleDrawer(val){
        this.$emit("toggleDrawer",val)
    },
    
    goToPage(page){
      if(this.onMasterConfiguration){
        location.href = page
      }
      this.$router.push(page, () => {});
    },
    
    logOut(){
      const myForm = document.getElementById('logOut');
      const formdata = new FormData(myForm);
        this.$store.commit('logout');

      axios({
        method: 'POST',
        url: 'logout',
        data: formdata
      }).then(() => {

      })
    },

    // toggleDialogMasterList(value){
    //     if(value){
    //       // console.log('tama')
    //       this.dialogMasterList = true;
    //     } else {
    //       // console.log('mali')
    //       this.dialogMasterList = false;
    //     }
    //   },

    // handleContextMenu(event) {
    //     // Prevent the default context menu behavior
    //     event.preventDefault();
    // },
    // handleKeyDown(event) {
    //   // Disable F12 and Ctrl+Shift+I (Windows/Linux) or Cmd+Option+I (Mac)
    //   if ((event.key === 'F12') || ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'I')) {
    //       event.preventDefault();
    //   }
    //   // Disable right-click
    //   if (event.button === 2) {
    //       event.preventDefault();
    //   }
    // },

  },

}
</script>

<style scoped>
  .btn-active{
    background-color: #546e7a !important;
    color: whitesmoke !important;
  }

  .textPosition{
    animation-direction: alternate;
    position: relative;
    animation: myPosition 8s linear infinite;
  }

  @keyframes myPosition {
  0%  {left: 0px;}
  25% {left: -50px;}
  50% {left: -100px;}
  75% {left: -150px;}
  100%  {left: -200px;}
}

</style>
